import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { AppService } from '../app.service';

@Component({
  selector: 'app-electron-close-modal',
  templateUrl: './electron-close-modal.component.html',
  styleUrls: ['./electron-close-modal.component.css']
})
export class ElectronCloseModalComponent {
  @Input() appService;
  constructor(public activeModal: NgbActiveModal) { }

  /** get text in right language 
  * @param {string} tag - text to load
  */
 get(tag:string):String {
	return this.appService.get(tag);
  }

}
